import PropTypes from "prop-types"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import LhoUnitIcon from "../../images/icons/lho_unit-104.png"
import { Drilldown, DrilldownItem, DrilldownList } from "../common"
import { referenceComparator } from "../common/Drilldown"
import { unitLabelFor, tenantLabelFor } from "../common/presentationFormatters"
import { t } from "../../i18next"

export default class UnitsDrilldown extends Component {
  static propTypes = {
    units: PropTypes.arrayOf(PropTypes.object).isRequired,
    unitTypes: PropTypes.array.isRequired,
    className: PropTypes.string,
  }

  render() {
    return (
      <Drilldown className={`lho-explorer-units-drilldown ${this.props.className}`} title={t("lho.units")}>
        <DrilldownList>
          {this.props.units.sort(referenceComparator).map(unit => (
            <DrilldownItem key={unit.reference}>
              <Link to={`/lho/${unit.reference}`}>
                <div className="icon-container">
                  <div className="icon">
                    <img className="icon-unit" alt="OB" src={LhoUnitIcon} />
                  </div>
                </div>
                <div className="info">
                  <div className="reference">{unit.reference}</div>
                  <div className="description">{unitLabelFor(unit, this.props.unitTypes)}</div>
                  <div className="tenant">{tenantLabelFor(unit)}</div>
                </div>
              </Link>
            </DrilldownItem>
          ))}
        </DrilldownList>
      </Drilldown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/lho-explorer/UnitsDrilldown.js